import { Component } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from "../../shared/services/auth.service";
import { GoogleAnalyticsService } from '../../shared/services/google-analytics.service';
import { signupTick } from '../../utils/images';

@Component({
  selector: 'app-restore-account',
  templateUrl: './restore-account.component.html',
  styleUrl: './restore-account.component.scss'
})
export class RestoreAccountComponent {

  public title = 'Your account has been restore';
  signupTick = signupTick;
  
  constructor(private authService: AuthService, private route: ActivatedRoute, private googleAnalytics: GoogleAnalyticsService) {this.restoreAccount()}

  restoreAccount() {

    const token = this.route.snapshot.params['token']

    this.authService.restoreAccount(token).subscribe(
      () => {
        this.title = 'Your account has been restore';
      },
      () => {
        this.title = 'Invalid or expired link';
      }
    )

  }

  trackButtonClick(btn_name: any) {
    this.googleAnalytics.trackButtonClick({'button': btn_name, page: 'Restore account'});
  }
}
